<template>
	<!-- <router-view></router-view> -->
	<div id="app">
		<!-- <home></home> -->
        <router-view></router-view>
	</div>
</template>

<script>
	//引入perfect-scrollbar 滚动条  链接：https://github.com/utatti/perfect-scrollbar  必要的写法：
	/*
	 * 1. import 'perfect-scrollbar/css/perfect-scrollbar.css';
		 2. var ps = new scrollbar('#app');
		 3. #app {
			position: absolute;
			width: 100%;
			height: 100%;
		}
	 */
//	 import scrollbar from 'perfect-scrollbar';
//	 import 'perfect-scrollbar/css/perfect-scrollbar.css';
	import home from './components/content/home/home_gd1'
	// import home from './components/content/home/selectImg'

	export default {
		name:'app',
		components: {
			home
		},
		mounted() {
			//var ps = new scrollbar('.app');
		}
	}
</script>

<style>
	/*html,body{
	    height:100%;
	}
	*{
		padding: 0;
		margin: 0;
		list-style:none;
	}
	html,body,h1,h2,h3,h4,h5,h6,div,dl,dt,dd,ul,ol,li,p,blockquote,pre,hr,figure,table,caption,th,td,form,fieldset,legend,input,button,textarea,menu{margin:0;padding:0;}
	header,footer,section,article,aside,nav,hgroup,address,figure,figcaption,menu,details{display:block;}
	table{border-collapse:collapse;border-spacing:0;}
	caption,th{text-align:left;font-weight:normal;}
	html,body,fieldset,img,iframe,abbr{border:0;}
	i,cite,em,var,address,dfn{font-style:normal;}
	[hidefocus],summary{outline:0;}
	li{list-style:none;}
	sup,sub{font-size:83%;}
	pre,code,kbd,samp{font-family:inherit;}
	q:before,q:after{content:none;}
	textarea{overflow:auto;resize:none;}
	label,summary{cursor:default;}
	a,button{cursor:pointer;}
	h1,h2,h3,h4,h5,h6,em,strong,b{font-weight:bold;}
	del,ins,u,s,a,a:hover{text-decoration:none;}
	body,textarea,input,button,select,keygen,legend{color:#333;outline:0;font-family: 'MicroSoft YaHei','Helvetica', 'Arial', sans-serif;}
	body{
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		-khtml-user-select: none;
		user-select: none;
		-webkit-text-size-adjust: none;
	    font-family: 'MicroSoft YaHei','Helvetica', 'Arial', sans-serif;
	    font-size:16px;
	}
	select::-ms-expand {
	    display: none;
	}
	input[type="text"]::-ms-clear {
	    display: none;
	}
	input:focus { outline: none; }
	input:-webkit-autofill{
		-webkit-box-shadow: 0 0 0px 1000px white inset !important;
		}
	button, input {
	    font-family: "Microsoft Yahei";
	}
	a{
		outline: 0;
	    text-decoration: none;
	    list-style: none;
	}
	#app {
		height:100%;
		background: #efefef;
	}*/
	.leaflet-control{
		display: none!important;
	}

    .dashLine {
        stroke-dasharray: 10; /* 地图道路绘制的虚线效果 */
    }
</style>



// WEBPACK FOOTER //
// src/App.vue